export default "__VITE_ASSET__ad8e569a__"